var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('router-link',{attrs:{"to":_vm.getUrlByName('settings.attribute.remoteCode', _vm.value),"target":_vm.target}},[(_vm.label)?[_vm._v(" "+_vm._s(_vm.label)+" ")]:_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }